import ZendeskTicketCell from './component';
import { compose, withHandlers, withState, withProps } from 'recompose';
import { connect } from 'react-redux';
import * as http from 'utils/http';
import config from 'config';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['shipper_orders'];

const checkIfIsFalseOrUndefiend = ({ not_assigned_notification_email }) => {
  if (!not_assigned_notification_email) return true;
  return false;
};

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { shipper_orders: shipperOrders } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );

    return {
      shipperOrders,
    };
  }),
  withProps(({ shipperOrders }) => ({
    show: (shipperOrders || []).some(checkIfIsFalseOrUndefiend),
  })),
  withState('creating', 'setCreating', false),
  withState('error', 'setErrorCreating', false),
  withState('created', 'setCreatedSuccesfully', false),
  withHandlers({
    handleCreateTicket:
      ({ setCreating, journeyId, setErrorCreating, setCreatedSuccesfully }) =>
      async (e) => {
        e.stopPropagation();
        try {
          setErrorCreating(false);
          setCreating(true);
          await http.post(`${config.API_URL}mercury/journeys/${journeyId}/notify_not_assigned/`);
          setCreating(false);
          setCreatedSuccesfully(true);
        } catch (e) {
          setCreating(false);
          setErrorCreating(true);
        }
      },
  })
);

export default enhance(ZendeskTicketCell);
